var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sendEmail" } }, [
    _c("div", {
      staticClass: "icon-util",
      class: [_vm.sendShow ? "check-small" : "nocheck-small-blue"],
      staticStyle: { float: "left" },
      on: {
        click: function($event) {
          return _vm.sendEmailClose()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "check-item-position",
        on: {
          click: function($event) {
            return _vm.sendEmailClose()
          }
        }
      },
      [_vm._v(_vm._s(_vm.$t("language.popup.sendEmail")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "send-email-body",
        class: _vm.sendShow ? "" : "check-none"
      },
      [
        _c("div", { staticClass: "send-email-item", class: _vm.shakeBox }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            staticClass: "send-email",
            attrs: {
              placeholder: _vm.$t("language.twoStepverification.enterEmail")
            },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "send-letter",
            on: {
              click: function($event) {
                return _vm.sendEmail()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("language.popup.sendMessage")))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c85301fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c85301fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_email.vue
// module id = null
// module chunks = 